import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { ConsumptionData, ICardsHttpService } from '../interfaces';
import { firstValueFrom } from 'rxjs';
import { CardCancellationResponseBack, CardConsumptionResponseBack, CardResponseBack, SessionsResponseBack } from '../interfaces/types';
import { API_DEFAULT_PARAMS } from '../constants';
import { ERROR_ACTION_KEY } from '../../../tokens';

@Injectable()
export class CardsHttpService implements ICardsHttpService {
  constructor(protected httpClient: HttpClient) {}

  getCard(country: string, numCard: string): Promise<CardResponseBack> {
    return firstValueFrom(
      this.httpClient.get<CardResponseBack>(`/cards/${numCard}`, {
        params: { country, photoEnabled: true },
        context: new HttpContext().set(ERROR_ACTION_KEY, 'errors.actions.card_details'),
      }),
    );
  }

  consumeCard(country: string, numCard: string, data: ConsumptionData): Promise<CardConsumptionResponseBack> {
    return firstValueFrom(
      this.httpClient.post<CardConsumptionResponseBack>(`/cards/${numCard}/consume`, data, {
        params: { country, transactionChannel: data.transactionChannel, posSystem: API_DEFAULT_PARAMS.posSystem },
        context: new HttpContext().set(ERROR_ACTION_KEY, 'errors.actions.validate_order'),
      }),
    );
  }

  getCardSessions(country: string, numCard: string): Promise<SessionsResponseBack> {
    return firstValueFrom(
      this.httpClient.get<SessionsResponseBack>(`/cards/${numCard}/sessions`, {
        params: { country },
        context: new HttpContext().set(ERROR_ACTION_KEY, 'errors.actions.card_sessions'),
      }),
    );
  }

  cancelCardOperation(
    country: string,
    numCard: string,
    consumeTransactionId: number,
    transactionChannel: string,
  ): Promise<CardCancellationResponseBack> {
    return firstValueFrom(
      this.httpClient.post<CardCancellationResponseBack>(
        `/cards/${numCard}/cancel`,
        {},
        {
          params: { country, consumeTransactionId, transactionChannel, posSystem: API_DEFAULT_PARAMS.posSystem },
          context: new HttpContext().set(ERROR_ACTION_KEY, 'errors.actions.cancel_order'),
        },
      ),
    );
  }
}
